<template>
    <section id="wrapper">
        <Preloader v-bind:class="{preloader: showPreloader}"></Preloader>
        <div class="login-register">
            <div class="login-box card">
                <div class="card-body">
                    <h4 v-if="showFailureMessage" class="bg-danger text-white text-center p-2 my-2">
                        Authentication Failed. <br/>{{errors.message}}
                    </h4>
                    <form class="form-horizontal form-material" id="loginform" @submit.prevent="signIn">
                        <h3 class="text-center m-b-20">Sign In</h3>
                        <div class="form-group ">
                            <div class="col-xs-12">
                                <input class="form-control" type="text" name="email" v-model.trim="$v.email.$model"
                                       placeholder="Email">
                            </div>
                            <div v-if="$v.email.$error">
                                <div class="text-danger" v-if="!$v.email.required">Email is required</div>
                                <div class="text-danger" v-if="!$v.email.email">Email is invalid.</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-xs-12">
                                <input class="form-control" type="password" name="password" v-model="$v.password.$model"
                                       placeholder="Password">
                            </div>
                            <div v-if="$v.password.$error">
                                <div class="text-danger" v-if="!$v.password.required">Password is required</div>
                                <div class="text-danger" v-if="!$v.password.minLength">Minimum 8 symbols</div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-md-12">
                                <div class="d-flex no-block align-items-center">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" name="rememberMe"
                                               v-model="rememberMe" id="customCheck1">
                                        <label class="custom-control-label" for="customCheck1">Remember me</label>
                                    </div>
                                    <div class="ml-auto">
                                        <a href="javascript:void(0)" id="to-recover" class="text-muted">
                                            <i class="fas fa-lock m-r-5"></i> Forgot pwd?
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group text-center p-b-20 p-t-20">
                            <div class="col-xs-6">
                                <button class="btn btn-info btn-rounded btn-md text-uppercase waves-effect waves-light">
                                    Log In
                                </button>
                            </div>
                        </div>
                        <div class="form-group m-b-0">
                            <div class="col-sm-12 text-center">
                                Don't have an account?
                                <router-link to="/register" class="text-info m-l-5"><b>Sign Up</b></router-link>
                            </div>
                        </div>
                    </form>
                    <form class="form-horizontal" id="recoverform" action="#">
                        <div class="form-group ">
                            <div class="col-xs-12">
                                <h3>Recover Password</h3>
                                <p class="text-muted">Enter your Email and instructions will be sent to you!</p>
                            </div>
                        </div>
                        <div class="form-group ">
                            <div class="col-xs-12">
                                <input class="form-control" type="text" required="" placeholder="Email">
                            </div>
                        </div>
                        <div class="form-group text-center m-t-20">
                            <div class="col-xs-12">
                                <button class="btn btn-primary btn-lg btn-block text-uppercase waves-effect waves-light"
                                        type="submit">Reset
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import '../../assets/scss/pages/login-register-lock.scss'
    import {required, minLength, email} from 'vuelidate/lib/validators';
    import {mapActions, mapState} from 'vuex';
    import Preloader from '../Preloader';
    import AuthService from '../../services/AuthService';

    export default {
        name: 'Login',
        components: {Preloader},
        data() {
            return {
                email: '',
                password: '',
                showFailureMessage: false,
                showPreloader: false,
                errors: {},
                rememberMe: false
            }
        },
        computed: {
            ...mapState({authenticated: state => state.auth.authenticated})
        },
        validations: {
            email: {required, email},
            password: {required, minLength: minLength(8)}
        },
        methods: {
            ...mapActions(['authenticate']),
            async signIn() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    this.showPreloader = true;
                    await this.authenticate({
                        email: this.email,
                        password: this.password
                    }).catch((error) => {
                        this.errors = error.response.data;
                        this.showPreloader = false;
                        this.showFailureMessage = true;
                    });
                    if (this.authenticated) {
                        if (this.rememberMe){
                            AuthService.rememberMe(this.rememberMe);
                        }
                        this.$router.push({name: 'home'});
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .login-register {
        background-image: url("../../assets/images/background/login-register.jpg");
    }
</style>